import { EEventType, type IProductEvent } from '@mahawi/eshop-rabbit/message';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import React from 'react';

import {
  ENotificationSeverity,
  type ShowNotificationMessage,
} from '../../admin-types';

dayjs.extend(relativeTime);

interface EventProductProps {
  message: IProductEvent;
  showNotification: (params: { message: ShowNotificationMessage }) => void;
}

// Event type mappings
const EVENT_MAPPINGS = {
  UPDATE: {
    severity: ENotificationSeverity.INFO,
    title: 'Product was updated',
    description: 'Product has been updated successfully.',
  },
  SYNCED_WITH_WAREHOUSE: {
    severity: ENotificationSeverity.INFO,
    title: 'Product was synced with warehouse',
    description: 'Product has been synced with the warehouse.',
  },
};

export const eventProduct = ({
  message,
  showNotification,
}: EventProductProps): void => {
  const eventType: EEventType = message.event.type;
  const eventMapping = EVENT_MAPPINGS[
    eventType as keyof typeof EVENT_MAPPINGS
  ] || {
    severity: ENotificationSeverity.INFO,
    title: `Unknown event type: ${eventType}`,
    description: `No description available for event type: ${eventType}`,
  };

  const timestamp: string = dayjs(message.timestamp * 1000).fromNow();

  const description: React.ReactElement = (
    <div>
      <p>{eventMapping.description}</p>
      {message.fields && message.fields.length > 0 && (
        <p>
          <Typography.Text strong>Fields:</Typography.Text>{' '}
          {message.fields.join(', ')}
        </p>
      )}
      <p>
        <Typography.Text strong>Timestamp:</Typography.Text> {timestamp}
      </p>
    </div>
  );

  showNotification({
    message: {
      severity: eventMapping.severity,
      title: eventMapping.title,
      description,
    },
  });
};
